


















import { Component, Prop, Vue } from 'vue-property-decorator';

import { IPark } from '@/models/IPark.model.ts';
import { ParksAPI } from '@/apis/parks.api';
import { UsersAPI } from '@/apis/users.api';
import { BookingAPI } from '@/apis/bookings.api';
import { IBooking } from '@/models/IBooking.model';

@Component({
    components: {},
})
export default class TabBookingsView extends Vue {

  @Prop() public bookings!: IBooking[];

  private first = false;

  public async downloadJSON() {
    const bookingApi = new BookingAPI();
    const bookings = await bookingApi.getAll();

    var jsonData = JSON.parse(JSON.stringify(bookings)+'');
    var content = JSON.stringify(jsonData);
    var fileName =  'bookings.json';
    var contentType =  'text/plain'
    var a = document.createElement("a");
    var file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

}
